import React from 'react';
import MainPartsHead from './MainParts_head';
import PhotoGrid from './PhotoGrid';
import PictureChanger from './PictureChanger';

// photos need to gallery
import {
  branding1,
  branding2,
  branding3,
  branding4,
  branding5,
  branding6,
  brochure1,
  brochure2,
  print1,
  print2,
  signage1,
  signage2,
  signage3,
  signage4,
  socialMedia1,
  socialMedia10,
  socialMedia11,
  socialMedia12,
  socialMedia2,
  socialMedia3,
  socialMedia4,
  socialMedia5,
  socialMedia6,
  socialMedia7,
  socialMedia8,
  socialMedia9,
} from '../../images/our_works/gallery';

// add new catagories is here
const category = [
  { id: 1, title: 'Social Media' },
  { id: 2, title: 'Brochures' },
  { id: 3, title: 'Branding' },
  { id: 4, title: 'Signages' },
  // { id: 5, title: 'Websites' },
  { id: 6, title: 'Prints' },
];



// add new picture is in here
const gallery = [
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia1,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia2,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia3,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia4,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia5,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia6,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia7,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia8,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia9,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia10,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia11,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Social Media',
    picture: socialMedia12,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Brochures',
    picture: brochure1,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Brochures',
    picture: brochure2,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Branding',
    picture: branding1,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Branding',
    picture: branding2,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Branding',
    picture: branding3,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Branding',
    picture: branding4,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Branding',
    picture: branding5,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Branding',
    picture: branding6,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Signages',
    picture: signage1,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Signages',
    picture: signage2,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Signages',
    picture: signage3,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Signages',
    picture: signage4,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Prints',
    picture: print1,
  },
  {
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    title: '',
    category: 'Prints',
    picture: print2,
  },
];

const MainParts = () => {
  const [isGalleryOpen, setIsGalleryOpen] = React.useState(false);
  const [swiperPosition, setSwiperPosition] = React.useState(0);

  const [isCategory, setIsCategory] = React.useState('Social Media');

  const galleryFiltered = () =>
    gallery.filter((item) => item.category === isCategory && item);

  return (
    <div className=" grid w-full overflow-hidden">
      <MainPartsHead
        category={category}
        isCategory={isCategory}
        setIsCategory={setIsCategory}
      />
      <PhotoGrid
        setIsGalleryOpen={setIsGalleryOpen}
        data={galleryFiltered().sort((a, b) => (b.id < a.id ? -1 : 1))}
        setSwiperPosition={setSwiperPosition}
      />
      <PictureChanger
        isGalleryOpen={isGalleryOpen}
        setIsGalleryOpen={setIsGalleryOpen}
        data={galleryFiltered().sort((a, b) => (b.id < a.id ? -1 : 1))}
        swiperPosition={swiperPosition}
        setSwiperPosition={setSwiperPosition}
      />
    </div>
  );
};

export default MainParts;
